import { createFileRoute } from "@tanstack/react-router";

import Notifications from "../../../components/settings/notifications/Notifications";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/notifications",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <Notifications />;
}
